import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function PlusIcon(props: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon viewBoxDimensions="0 0 24 24" {...props}>
      <path
        d="M5 12H19M12 5V19"
        fill="none"
        stroke={props.stroke ?? 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </SimpleIcon>
  );
}
